export const showInfoMessage = (messages,detail) => {
    messages.current.show({ severity: 'info',
        detail,
        closable: true,
        life: 3000 });
};

export const showWarnMessage = (messages,detail) => {
    messages.current.show({ severity: 'warn',
        detail,
        closable: true,
        life: 3000 });
};

export const showErrorMessage = (messages,detail) => {
    messages.current.show({
        severity: 'error',
        detail,
        closable: true,
        life: 3000
    });
};

export const showSuccessMessage = (messages,detail) => {
    messages.current.show({
        severity: 'success',
        detail,
        closable: true,
        life: 3000
    });
};